/**
 * Default layout configuration
 */

import type { GraphLayoutConfig } from './graph-layout-config.js'

export const DEFAULT_LAYOUT_CONFIG: GraphLayoutConfig = {
  nodeWidth: 200,
  nodeHeight: 80,
  horizontalSpacing: 80,
  verticalSpacing: 100,
  orientation: 'ttb',
}
